import { Actions } from 'vuex-smart-module';
import { PurchaseOrdersService } from '@/modules/purchase-orders/services';
import { FilesRequest } from '@/modules/purchase-orders/types';
import FilesState from './state';
import FilesMutations from './mutations';
import FilesGetters from './getters';

const purchaseOrdersService = new PurchaseOrdersService();

export default class FilesActions extends Actions<
  FilesState,
  FilesGetters,
  FilesMutations,
  // eslint-disable-next-line no-use-before-define
  FilesActions
> {
  async get_files(id: string | number) {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const payload: FilesRequest = {
        filters: [],
        filters_exist: true,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING_FILES(true);
      const { data, meta } = await purchaseOrdersService.get_files(id, payload);

      this.mutations.SET_FILES(data.items);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
    } catch (error) {
      console.error(error);
    } finally {
      this.mutations.TOGGLE_LOADING_FILES(false);
    }
  }

  async add_file(id: string | number) {
    const formData = new FormData();

    formData.append('file', this.state.file!);

    try {
      const { data } = await purchaseOrdersService.add_file(id, formData);

      this.mutations.ADD_FILE(data);
    } catch (error) {
      console.log(error);
    }
  }
}
